import { createV3Queries } from "@query/utils/createV3Queries";
import { payablesApi } from "@api";

export const queriesPayables = createV3Queries("payablesApi", payablesApi);
